import React, { useEffect } from 'react';
import CustomEAHero from '../components/CustomEAHero';
import CustomEAForm from '../components/CustomEAForm';
import CustomEACtaBanner from '../components/CustomEACtaBanner';
import BuildStandards from '../components/BuildStandards';

const CustomEA = () => {
  useEffect(() => {
    // Add scroll observer for reveal animations in this new page
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                
                // Stagger logic for items within the section
                const staggeredItems = entry.target.querySelectorAll('.stagger-item');
                staggeredItems.forEach((item, index) => {
                    item.style.transitionDelay = `${index * 0.1}s`;
                    item.style.opacity = '1';
                    item.style.transform = 'translateY(0)';
                });
            }
        });
    }, observerOptions);

    document.querySelectorAll('.reveal-on-scroll').forEach(section => {
        const staggeredItems = section.querySelectorAll('.stagger-item');
        staggeredItems.forEach(item => {
            item.style.opacity = '0';
            item.style.transform = 'translateY(20px)';
            item.style.transition = 'all 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
        });
        observer.observe(section);
    });
    
    return () => observer.disconnect();
  }, []);

  return (
    <main className="min-h-screen pt-12">
      <CustomEAHero />
      <CustomEAForm />
      <CustomEACtaBanner />
      <BuildStandards />
    </main>
  );
};

export default CustomEA;
